import { Cancel } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import React from 'react';
import styles from './RemoveCell.module.scss';

export interface RemoveCellProps {
    onClick: () => void;
    isDisabled?: boolean;
}

export const RemoveCell = ({
    onClick,
    isDisabled = false,
}: RemoveCellProps) => {
    const onRemoveCellClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onClick();
    };

    return (
        <div className={styles.removeCell} data-testid="RemoveCell">
            <IconButton
                disabled={isDisabled}
                onClick={onRemoveCellClick}
                color={isDisabled ? 'default' : 'error'}
            >
                <Cancel className={styles.button} />
            </IconButton>
        </div>
    );
};
